import React, { useEffect, useState } from 'react';
import File from '../../extras/File';
import { getCiegDocuments, normalizeCiegDocument } from '../../../services/ciegDocumentsService';

const CiegDocumentsPage = ({ title, categoryPath, colSize = 2 }) => {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        setLoading(true);
        getCiegDocuments(categoryPath)
            .then((data) => {
                if (mounted) {
                    setDocuments(data.map(normalizeCiegDocument));
                }
            })
            .catch((error) => {
                console.log(error);
                if (mounted) {
                    setDocuments([]);
                }
            })
            .finally(() => {
                if (mounted) {
                    setLoading(false);
                }
            });

        return () => {
            mounted = false;
        };
    }, [categoryPath]);

    return (
        <div className='container'>
            <br />
            <div className='row'>
                <div className='col-lg-12 text-center'>
                    <h2>{title}</h2>
                </div>
            </div>
            <hr />
            {loading &&
                <div className='row'>
                    <div className='col-lg-12 text-center'>
                        <p>Cargando...</p>
                    </div>
                </div>
            }
            {!loading && documents.length === 0 &&
                <div className='row'>
                    <div className='col-lg-12 text-center'>
                        <p>No hay archivos disponibles.</p>
                    </div>
                </div>
            }
            <div className='row'>
                {documents.map((document) => (
                    <File doc={document} key={document.id || document.file} colSize={colSize} />
                ))}
            </div>
            <br /><br /><br /><br /><br />
        </div>
    );
};

export default CiegDocumentsPage;
